import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React from "react";

function SignRequestNotFound(props) {
    const {t, _} = useTranslation();
    return (
        <div>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item>
                    <br/>
                    <Typography variant={"h6"}>{t("not_found_sign_request_title")}</Typography>
                    <Typography variant={"body1"}>
                        {t("not_found_sign_request_description")}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
}

export default SignRequestNotFound;